import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCIOFUoUOI3LFls5NQfss7EgzKnpNk6qpc",
  authDomain: "payroll-swg.firebaseapp.com",
  projectId: "payroll-swg",
  storageBucket: "payroll-swg.firebasestorage.app",
  messagingSenderId: "877999168203",
  appId: "1:877999168203:web:e5f9e72e06396963f0994e"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const functions = getFunctions(app);
const projectId = firebaseConfig.projectId;
const realtimeDb = getDatabase();

// Ensure the user session persists across refresh
setPersistence(auth, browserLocalPersistence);

//export default db;

export { db, auth, googleProvider, functions, projectId, realtimeDb, httpsCallable};